function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.994 203.994",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M202.205,39.33H1.786C0.798,39.33,0,40.128,0,41.119v121.767c0,0.981,0.798,1.779,1.786,1.779 h200.419c0.984,0,1.789-0.798,1.789-1.779V41.119C203.994,40.128,203.189,39.33,202.205,39.33z M200.419,161.1H3.572V109.88h37.216 c0.83,0,1.55-0.576,1.739-1.374l4.642-19.405l3.786,19.333c0.161,0.83,0.895,1.446,1.746,1.446h11.914 c0.888,0,1.643-0.662,1.768-1.542l6.012-42.062l11.302,76.033c0.125,0.87,0.88,1.521,1.761,1.521h0.057 c0.902-0.029,1.646-0.734,1.725-1.632l2.838-32.313h6.703c0.877,0,1.625-0.644,1.768-1.514l3.701-23.245l4.695,22.15 c0.175,0.823,0.902,1.41,1.746,1.41h42.527c0.641,2.162,2.616,3.74,4.975,3.74c2.881,0,5.214-2.326,5.214-5.204 c0-2.888-2.333-5.214-5.214-5.214c-2.129,0-3.951,1.278-4.76,3.106h-41.3l-6.392-30.152c-0.175-0.834-0.963-1.41-1.797-1.41 c-0.862,0.018-1.585,0.651-1.718,1.503l-4.978,31.247h-6.811c-0.923,0-1.704,0.712-1.782,1.632l-1.653,18.875l-10.88-73.184 c-0.129-0.873-0.877-1.521-1.768-1.521l0,0c-0.891,0-1.643,0.659-1.768,1.532l-7.53,52.666h-8.886l-5.082-25.95 c-0.157-0.827-0.877-1.428-1.714-1.439c-0.945,0.029-1.582,0.548-1.775,1.364l-6.227,26.025H3.572V42.901h196.848V161.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcgIcon);
export default __webpack_public_path__ + "static/media/EcgIcon.3fa0a09e5e5da0867c3a1a923a8f3e5a.svg";
export { ForwardRef as ReactComponent };